<template>
  <div class="main_container main_container_fixed">
      <div class="sub_container w-row">
        <div class="column-10 w-col w-col-3"></div>
        <div class="column-2 w-col w-col-6">
          <img src="@/assets/images/Group-11560.svg" loading="lazy" width="126" alt="" class="image-4" />
          <h1 class="heading-3" v-html="$t(helpTexts[step])"></h1>
        </div>
      </div>
      <div class="sub_container w-form">
        <insured-person-details v-if="step === 1 && data.CS_POLICY_HOLDER" :data="data" @next="updateStep" />
        <select-package v-if="step === 2 && data.CT_PACKAGES" :data="data" @next="submit" @select-package="SelectPackage" />
      </div>
      <div class="sub_container footer w-row">
        <div class="column_footer_b w-clearfix w-col w-col-6">
          <img src="@/assets/images/Group-10068.svg" loading="lazy" alt="" class="image-5" />
          <p class="bold_label">{{ $t('FIELDS_REQUIRED_EXCEPT') }}</p>
        </div>
        <div class="column_footer_b w-clearfix w-col w-col-6">
          <img src="@/assets/images/Group-11600.svg" loading="lazy" alt="" class="image-6" />
          <p class="bold_label">
            {{ $t('FIELDS_CHECKED_TOM_CALCULATED_COST') }}
          </p>
        </div>
      </div>
    <!-- <gdpr-details v-if="step === 2 && data.CS_POLICY_HOLDER" :data="data" @submit="updateStep" /> -->
  </div>
</template>

<script>
import InsuredPersonDetails from '@/views/Motor/SendOffer/SendOfferComponents/InsuredPersonDetails.vue';
import { mapState, mapActions } from 'vuex';
// import Vue from 'vue';

export default {
  data() {
    return {
      step: 1,
      helpTexts: {
        1: 'INSURED_PERSON_DETAILS',
        2: 'PACKAGE_SELECTION'
      }
    };
  },
  components: {
    InsuredPersonDetails,
    // GdprDetails: () => import('@/views/Motor/SendOffer/SendOfferComponents/GdprDetails.vue'),
    SelectPackage: () => import('@/views/Motor/SendOffer/SendOfferComponents/SelectPackage.vue')
  },
  computed: {
    ...mapState({
      data: (state) => state.motor.motor,
      send_via_email: (state) => state.motor.send_via_email
    })
  },
  async created() {
    if (!(this.data.IS_USER_ADD_FIELDS && this.data.IS_USER_ADD_FIELDS.SEND_VIA_MAIL && this.send_via_email)) {
      this.$router.push({ path: '/motor' });
    }
  },
  methods: {
    ...mapActions('motor', ['motorUpdateDataAction', 'motorQuotationAction', 'motorSelectPackageAction']),
    updateStep() {
      this.motorUpdateDataAction(this.data);
      this.step++;
    },
    SelectPackage(item) {
      this.motorSelectPackageAction(item);
    },
    async submit() {
      const {
        CS_VEHICLE, CS_DRIVERS, CS_POLICY_HOLDER, CS_PROMO_CODE, CS_POLICY, CT_COVERS
      } = this.data;
      await this.motorQuotationAction({
        CS_VEHICLE,
        CS_DRIVERS,
        CS_POLICY_HOLDER,
        CS_PROMO_CODE,
        CS_POLICY,
        CT_COVERS
      });
      this.$router.push({ path: '/motor/offer' });
      console.log('send email');
    }
  }
};
</script>
